/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IOneplusXConfiguration } from "@almamedia/amr-adtech-stack/lib/services/dmp/providers/1plusx/1plusx";
import { StackContext } from "../context";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";

async function preDataCollection(c: StackContext) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const dl = c.services.dataLayerService!.dataLayer;
  if (dl.pageType === "article" && dl.subCategory1 === "artikkeli") {
    return {
      props: {},
    };
  }

  return { reason: `Data collection ignored for ${dl.locationHref}` };
}

const oneplusXConfig: IOneplusXConfiguration<
  ICustomVariables,
  SiteNativeTemplate
> = {
  clientId: "almamedia",
  preDataCollection,
};

export default oneplusXConfig;